import { $api } from "@/lib/api";
import type { Organization } from "@/modules/auth/types/organization.types";

interface UseUserOrganizationsReturn {
  currentOrganization: Organization | null;
  availableOrganizations: Organization[];
  isLoading: boolean;
}

/**
 * Hook to fetch organization data from the API
 */
export const useUserOrganizations = (): UseUserOrganizationsReturn => {
  const { data, isLoading } = $api.useQuery(
    "get",
    "/v1/users/me/organizations",
  );

  return {
    currentOrganization: (data?.currentOrganization as Organization) ?? null,
    availableOrganizations:
      (data?.organizations as unknown as Organization[]) ?? [],
    isLoading,
  };
};
